import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children, requireRole }) {
    const { user } = useAuth();
    const location = useLocation();
    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
                <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Loading</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
    if (requireRole && !requireRole.includes(user.role)) {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
}
